import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { CustomValidator } from 'src/app/shared/directives/custom.validator';

@Injectable({
  providedIn: 'root'
})
export class AuctionValidationService {

  constructor() { }
  // newAuctionFormValidation(defualtValue?: any): object {
  //   const validation: object = {
  //     name_ar: new FormControl(defualtValue?.name_ar || '', [Validators.required, Validators.maxLength(100)]),
  //     name_en: new FormControl(defualtValue?.name_en || '', [Validators.required, Validators.maxLength(100)]),
  //     description_ar: new FormControl(defualtValue?.description_ar || '', [Validators.maxLength(255)]),
  //     description_en: new FormControl(defualtValue?.description_en || '', [Validators.maxLength(255)]),
  //     minimum_price: new FormControl(defualtValue?.minimum_price || '', [Validators.required, Validators.maxLength(20)]),
  //     is_published: new FormControl(defualtValue?.is_published || false, [Validators.required]),
  //     is_timer: new FormControl(defualtValue?.is_timer || false, [Validators.required]),
  //     total_minutes: new FormControl(defualtValue?.total_minutes || 0),
  //     btns: new FormArray(
  //       defualtValue?.btns.length ?
  //         [...defualtValue?.btns.map((item: { price: string }) => new FormGroup({ price: new FormControl(item.price || '', [Validators.required, Validators.maxLength(20)]) }))]
  //         : [new FormGroup({ price: new FormControl('', [Validators.required]) })]),

  //     details: new FormArray(
  //       defualtValue?.details.length ?
  //         [...defualtValue?.details.map((item: { key: string, value: string, lang: string }) =>
  //           new FormGroup({
  //             key: new FormControl(item.key || '', [Validators.required, Validators.maxLength(50)]),
  //             value: new FormControl(item.value || '', [Validators.required, Validators.maxLength(50)]),
  //             lang: new FormControl(item.lang || '', [Validators.required]),
  //           }))]
  //         : [new FormGroup({
  //           key: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  //           value: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  //           lang: new FormControl('en', [Validators.required])
  //         }),
  //         new FormGroup({
  //           key: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  //           value: new FormControl('', [Validators.required, Validators.maxLength(50)]),
  //           lang: new FormControl('ar', [Validators.required])
  //         })]),
  //     date: new FormControl(defualtValue?.date || null, [Validators.required]),
  //     start_at: new FormControl(defualtValue?.start_at || null, [Validators.required]),
  //     end_at: new FormControl(defualtValue?.end_at || null, [Validators.required]),
  //     link_streaming: new FormControl(defualtValue?.link_streaming || null, [Validators.required, Validators.maxLength(255), Validators.pattern("[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?")]),
  //   };
  //   return validation;
  // }

  public myreg =
    /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+$/;

  MainInfoValidation(defualtValue?: any): object {
    const validation: object = {
      name_ar: new FormControl(defualtValue?.name_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(100)]),
      name_en: new FormControl(defualtValue?.name_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(100), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
      description_ar: new FormControl(defualtValue?.description_ar || '', [Validators.maxLength(255)]),
      description_en: new FormControl(defualtValue?.description_en || '', [Validators.maxLength(255), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
      date: new FormControl(defualtValue?.date || null),
      start_at: new FormControl(defualtValue?.start_at || null),
      end_at: new FormControl(defualtValue?.end_at || null),
      category_id: new FormControl(defualtValue?.category?.id || null, [Validators.required]),
      room_id: new FormControl(defualtValue?.room?.id || null, [Validators.required])
    }
    return validation;
  }

  RoomDetails(defualtValue?: any): object {
    const validation: object = {
      details: new FormArray(
        defualtValue?.details.length ?
          [...defualtValue?.details.map((item: { key_en: string, value_en: string, key_ar: string, value_ar: string, order: string, id_en: string, id_ar: string }) =>
            new FormGroup({
              key_en: new FormControl(item.key_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
              value_en: new FormControl(item.value_en || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50), Validators.pattern(/^[a-zA-Z0-9!@#$%^&*()_+{}\[\]:;\"'<>,.?\/\\|\-=`~\s\n\r]*$/)]),
              key_ar: new FormControl(item.key_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)]),
              value_ar: new FormControl(item.value_ar || '', [CustomValidator.noWhiteSpace, Validators.maxLength(50)])
            }))]
          : [])
    }

    return validation
  }

  RoomConfigrations(defualtValue?: any): object {
    const validation: object = {
      minimum_price: new FormControl(defualtValue?.minimum_price || '', [Validators.required, Validators.maxLength(9)]),
      is_published: new FormControl(defualtValue?.is_published || false, [Validators.required]),
      reserve_price: new FormControl(defualtValue?.reserve_price || null),
      is_reserve: new FormControl(defualtValue?.is_reserve || false),
      manual_bidding: new FormControl(defualtValue?.manual_bidding || null, [Validators.required, Validators.maxLength(9)]),
      // link_streaming: new FormControl(defualtValue?.link_streaming || null, [Validators.required, Validators.maxLength(255), Validators.pattern(this.myreg)]),
      btns: new FormArray(
        defualtValue?.btns.length ?
          [...defualtValue?.btns.map((item: { price: string }) => new FormGroup({ price: new FormControl(item.price || null, [Validators.required, Validators.maxLength(9)]) }))]
          : [
            new FormGroup({ price: new FormControl(null, [Validators.required, Validators.maxLength(9)]) }),
            new FormGroup({ price: new FormControl(null, [Validators.required, Validators.maxLength(9)]) }),
            new FormGroup({ price: new FormControl(null, [Validators.required, Validators.maxLength(9)]) })
          ])
    }

    return validation
  }

}
